export default {
  colors: {
    primary: "#3f51b5",
    primaryDark: "#303F9F",
    primaryLight: "#C5CAE9",

    secondary: "#D3D3D3",
    secondaryLight: "#F0F0F0",

    light: "#FFFFFF",
    light2: "#f8f9fa",
    lightBluer: "#E3F2FD", // Azul bem claro tipo chat WhatsApp recebido

    dark: "#363F5F",
    darkGrey: "#808080",
    gray: "#B0B0B0",

    success: "#12A454",
    attention: "#E83F5B",
    alert: "#FFC107",
    information: "#2196F3",

    background: "#F9F9F9",

    // Cores específicas para mensagens
    messageSent: "#C5CAE9", // Azul claro (enviado)
    messageReceived: "#E3F2FD", // Azul ainda mais claro (recebido)
  },

  fonts: {
    regular: "Poppins_400Regular",
    medium: "Poppins_500Medium",
    bold: "Poppins_700Bold",
  },
};
